import { localDateToYmd, type DateRange } from '@nudool/design-system';

import { startOfPickedDay } from '../../../lib/start-of-picked-day.js';
import type { TransferOrderWhere } from '../transfer-order-list-operations.js';

// The Created column shows each order's Pacific day, so a picked day cuts at Pacific midnight. The
// end is an exclusive `lt` at the next Pacific day's start: date_created keeps microseconds, so a
// last-millisecond `lte` would drop a row at 23:59:59.9995.
export function buildDateCreatedWhere(
  dateCreated: DateRange | undefined,
): TransferOrderWhere['dateCreated'] {
  const { from, to } = dateCreated ?? {};
  if (!from && !to) return undefined;
  return {
    ...(from ? { gte: startOfPickedDay(localDateToYmd(from)) } : {}),
    ...(to ? { lt: startOfPickedDay(localDateToYmd(to), 1) } : {}),
  };
}
